/**
 * useIsFlagEnabled: returns a helper that checks whether a per-ecosystem
 * feature flag is enabled for the current tenant.
 *
 * The contract is default-allow: a featureKey absent from the capabilities
 * object is treated as enabled. Only an explicit `false` disables it.
 * A null/undefined featureKey always returns true (the feature is ungated).
 * The platform apex always returns true regardless of capabilities.
 *
 * @returns {(featureKey: string|null|undefined) => boolean}
 */
import { useEcosystem } from '@/shared/contexts/EcosystemContext';

export default function useIsFlagEnabled() {
    const { isPlatform, capabilities } = useEcosystem();

    return (featureKey) => {
        if (!featureKey) return true;
        if (isPlatform) return true;
        if (!capabilities) return true;
        return capabilities[featureKey] !== false;
    };
}
